module.exports = __webpack_public_path__ + "img/home.df6e5c65.png";